export default __webpack_public_path__ + "f18ad4fdd6099021d99a1f6f01296d67.png";